import { Link } from "react-router-dom";
import { setCurrentStep } from "../AddAccountSlice";
import translations from "utils/translationUtility";

export const SuccessStep = () => {
  return (
    <>
      <div className="card-body p-9">
        <h1 className="text-success mb-4">
          Your {translations.client.toLocaleLowerCase()} account has been linked successfully!
        </h1>
        <Link to="/" className="cpl-btn cpl-btn-primary" data-test-id="add-account-form__done-link">
          Done
        </Link>
        <button
          type="submit"
          className="cpl-btn cpl-btn-primary ms-3"
          data-test-id="add-account-form__add-another-account-button"
        >
          Add another account
        </button>
      </div>
    </>
  );
};

export const SuccessSubmit = ({ dispatch, helpers }) => {
  dispatch(setCurrentStep(0));
  helpers.resetForm();
};
